import {SEVERITY_LEVELS} from '../../../constants/StatusConstants'

// Helper function to map severity value to label
export const getBPSeverityLabel = (severityValue: string | number): string => {
  // Ensure the severityValue is a string to match against the SEVERITY_LEVELS
  const value = severityValue.toString()

  const severity = Object.values(SEVERITY_LEVELS).find((level) => level.value === value)

  return severity ? severity.label : 'N/A'
}

export const getNotificationMessage = (data: any) => {
  const systolic = data?.data?.systolic_pressure
  const diastolic = data?.data?.diastolic_pressure
  const pulse = data?.data?.pulse
  const severity = getBPSeverityLabel(data?.data.severity)

  const patientName = data.Patient ? `${data.Patient.full_name}` : 'The patient'

  let message = `${patientName} has blood pressure at the ${severity} stage with values ${systolic}/${diastolic} mmHg`

  if (pulse) {
    message += ` and pulse ${pulse} bpm`
  }

  return message
} 